import { apiClient } from "shared/api/client";

/**
 * Pobiera informacje o dyskach RBD użytkownika
 * @param {string} username - nazwa użytkownika
 * @param {string} apiUrl - baza URL API (np. https://ceph.example.com)
 * @returns Promise z danymi dysku
 */
export const getUserDisks = ({ apiUrl, username }) => {
  return apiClient(`${apiUrl}/ti/api/ceph/summary/?user=${username}`);
};